import Box from '@mui/material/Box'
import { useIntl } from 'react-intl'
import { severityIcon, severityToken } from '../../utils/severityTokens'
import { messages } from './messages'
import { useSystemStatusContext } from './SystemStatusProvider'
import StatusPillButton from './StatusPillButton'

// Appears in the top bar only when every active message has been dismissed, so
// the information is never lost. Styled by the highest active severity;
// clicking restores the dismissed stack for this session.
const SystemStatusPill = () => {
  const intl = useIntl()
  const {
    hasHiddenMessages,
    hiddenCount,
    highestSeverity,
    restoreAll
  } = useSystemStatusContext()

  if (!hasHiddenMessages || highestSeverity === null) {
    return null
  }

  const token = severityToken(highestSeverity)
  const Icon = severityIcon(highestSeverity)
  const label =
    hiddenCount === 1
      ? intl.formatMessage(messages.pillSingular, { count: hiddenCount })
      : intl.formatMessage(messages.pill, { count: hiddenCount })

  return (
    <StatusPillButton
      bg={token.bg}
      borderColor={token.border}
      textColor={token.chipText}
      onClick={restoreAll}
      aria-label={label}
      // match the ?-icon ↔ profile gap (the profile button's 15px padding)
      sx={{ mr: '15px' }}
    >
      <Icon sx={{ fontSize: 15, color: token.icon }} />
      <Box component="span">{label}</Box>
    </StatusPillButton>
  )
}

export default SystemStatusPill
